export default "__VITE_ASSET__bafa0f47__"